import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Tabs } from 'antd';
import { useSearchParams, useLocation } from 'react-router-dom';
import { Box } from 'atoms';
import {
	ApprovedTaskFrom,
	AutoApprovedTaskFrom,
	PendingTaskFrom,
	RejectedTrips,
	PODTaskForm,
} from 'components/forms/approval';
import { ACL } from 'components/common';
import { useAuth } from 'hooks';
import InvoiceEditApprovalOldUI from './components/InvoiceEditApprovalOldUI';

export default function AllApprovals() {
	const [activeTab, setActiveTab] = useState(1);
	const [searchParams, setSearchParams] = useSearchParams();
	const location = useLocation();
	const { permissions } = useAuth();
	const [approvalType] = useState('trip');
	console.log(setSearchParams);

	// Check if we're on invoice edit approval route
	const isInvoiceEditApprovalRoute = location.pathname === '/approvals/invoice-edit-approval';

	const onChange = useCallback(
		(key) => {
			/**
			 * On Edit mode only allow to go other other tabs
			 */ const newQueryParameters = new URLSearchParams();
			console.log('newQueryParameters', newQueryParameters);
			setSearchParams({
				...newQueryParameters,
				tab: key,
			});

			setActiveTab(key);
		},
		[setSearchParams]
	);

	useEffect(() => {
		const tab = Number(searchParams.get('tab'));
		console.log('Client Form tab', tab);

		if (tab) {
			onChange(tab);
		}
	}, [onChange, searchParams]);

	useEffect(() => {
		console.log('Client Form activeTab', activeTab);
	}, [activeTab]);

	const canViewPOD =
		permissions?.search?.includes('proof_of_delivery') || permissions?.search?.includes('all');

	const tabs = useMemo(
		() => [
			{
				id: 1,
				label: 'Pending',
				form: <PendingTaskFrom tab={activeTab} approvalType={approvalType} />,
			},
			{
				id: 2,
				label: 'Approved',
				form: <ApprovedTaskFrom tab={activeTab} />,
			},
			{
				id: 3,
				label: 'Auto Approved',
				form: <AutoApprovedTaskFrom tab={activeTab} />,
			},
			{
				id: 4,
				label: 'Reject',
				form: <RejectedTrips tab={activeTab} />,
			},
			...(canViewPOD
				? [
						{
							id: 5,
							label: 'POD',
							form: (
								<ACL action="search" module="proof_of_delivery">
									<PODTaskForm tab={activeTab} />
								</ACL>
							),
						},
				  ]
				: []),
		],
		[activeTab, canViewPOD, approvalType]
	);

	// If on invoice edit approval route, show invoice edit approval component
	if (isInvoiceEditApprovalRoute) {
		return <InvoiceEditApprovalOldUI />;
	}

	return (
		<Box>
			<Tabs
				onChange={onChange}
				tabPosition="top"
				type="line"
				activeKey={activeTab}
				defaultActiveKey={1}
				items={tabs.map((tab) => ({
					label: `${tab.label}`,
					key: tab.id,
					children: tab.form,
				}))}
			/>
		</Box>
	);
}
